import {algoliasearch} from "algoliasearch";
import {CLAVEAPP, CLAVEESCRITURA} from "../Constantes";

export const registrarDoc = async ({nombreIndex, obj}) => {

    if (obj.id) {
        obj.objectID = obj.id
    } else {
        alert('El documento no tiene id')
        return
    }

    const client = algoliasearch(CLAVEAPP, CLAVEESCRITURA);


    return client.saveObject({
        indexName: nombreIndex,
        body: obj,
    });


}